export default __webpack_public_path__ + "413e2b8d750cb60c6f58801402d67fb6.svg";